// Copyright (c) 2017 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import TcsmApproveDenyModal, {getDefaultState as getTcsmApproveDenyModalDefaultState} from '../../wip/state/tcsm-approve-deny-modal';
import massLaborRate, {getDefaultState as getMassLaborRateDefaultState} from './mass-labor-rates';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    laborRate: massLaborRate,
    modal: TcsmApproveDenyModal,
    selectedDealers: massLaborRate
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        laborRate: getMassLaborRateDefaultState(),
        modal: getTcsmApproveDenyModalDefaultState(),
        selectedDealers: getMassLaborRateDefaultState()
    });

export default State;



// WEBPACK FOOTER //
// ./src/tcsm/labor-rate-approval/state/index.js